module.exports = __webpack_public_path__ + "img/eighteen.1c86a6a0.png";